export default __webpack_public_path__ + "static/media/en.9fdcdb38.jpg";